import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import { validatePassword, PASSWORD_HINT } from '../passwordPolicy';
import PasswordInput from '../components/PasswordInput';

export default function ResetPassword() {
  const [newPassword, setNewPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const token = new URLSearchParams(window.location.search).get('token');

  const handleSubmit = async () => {
    setError('');
    if (!newPassword || !confirm) return setError('All fields are required');
    if (newPassword !== confirm) return setError('Passwords do not match');
    const passwordError = validatePassword(newPassword);
    if (passwordError) return setError(passwordError);
    setLoading(true);
    try {
      await axios.post('/api/auth/reset-password', { token, newPassword });
      setSuccess(true);
      setTimeout(() => navigate('/login'), 3000);
    } catch(e) {
      setError(e.response?.data?.error || 'Invalid or expired reset link');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-green-50 flex items-center justify-center">
      <div className="bg-white p-8 rounded-xl shadow-md w-full max-w-md">
        <h1 className="text-3xl font-bold text-green-700 mb-2 text-center">⛳ Golf Society Manager</h1>
        <h2 className="text-xl font-semibold text-gray-600 mb-6 text-center">Set New Password</h2>
        {error && <div className="bg-red-100 text-red-700 px-4 py-2 rounded mb-4 text-sm">{error}</div>}
        {success ? (
          <div className="bg-green-100 text-green-700 px-4 py-3 rounded text-sm text-center">
            Password changed successfully! Redirecting to login...
          </div>
        ) : (
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">New Password</label>
              <PasswordInput value={newPassword} onChange={e => setNewPassword(e.target.value)}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-green-500" />
              <p className="text-sm font-medium text-gray-600 mt-1">{PASSWORD_HINT}</p>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Confirm New Password</label>
              <PasswordInput value={confirm} onChange={e => setConfirm(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && handleSubmit()}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-green-500" />
            </div>
            <button onClick={handleSubmit} disabled={loading}
              className="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-2 px-4 rounded-lg text-sm">
              {loading ? 'Saving...' : 'Set New Password'}
            </button>
          </div>
        )}
        <p className="text-center text-sm text-gray-500 mt-4">
          <Link to="/login" className="text-green-600 hover:underline">Back to Sign In</Link>
        </p>
        <p className="text-center text-xs text-gray-400 mt-6">© 2026 Michael Sellman. Golf Society Manager.</p>
      </div>
    </div>
  );
}
